export const APP_ROOT_ROUTE_ID = 'app-root';
export const SERVICES_ROUTE_ID = 'services';
export const SCHEDULE_ROUTE_ID = 'schedule';
export const APPOINTMENT_TIME_PREFERENCE_ROUTE_ID =
  'appointment-time-preference';
export const INTAKE_QUIZ_ROUTE_ID = 'intake-quiz';
export const RESCHEDULE_ROUTE_ID = 'reschedule';
export const EMAIL_ROUTE_ID = 'email';
export const PHONE_ROUTE_ID = 'phone';
export const CONFIRM_YOUR_NUMBER_ROUTE_ID = 'confirm-your-number';
export const COMPLETE_PROFILE_ROUTE_ID = 'complete-profile';
export const CREATE_PASSWORD_ROUTE_ID = 'create-password';
export const COMPLETE_BOOKING_ROUTE_ID = 'complete-booking';
export const DRUG_SCREEN_ROUTE_ID = 'drug-screen';
export const BOOKING_CONFIRMATION_ROUTE_ID = 'booking-confirmation';
export const UPLOAD_DRUG_SCREEN_ROUTE_ID = 'upload-drug-screen';
export const ID_VERIFICATION_ROUTE_ID = 'id-verification';
export const DESIGN_SYSTEM_ROUTE_ID = 'design-system';
export const DEV_TOOLS_SANDBOX_ROUTE_ID = 'dev-tools-sandbox';
export const CHAT_WIDGET_NATIVE_WEBVIEW_ROUTE_ID = 'chat-widget-native-webview';
export const AUTH_VALIDATE_ROUTE_ID = 'auth-validate';
export const INTAKE_FORM_ROUTE_ID = 'intake-form';
export const REFILLS_ROUTE_ID = 'refills';
export const REFERRAL_ROUTE_ID = 'referral';
